import React from 'react';
import { FieldProvider, useFieldApi } from '@data-driven-forms/react-form-renderer';
import { Box, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';


export const ProductVariantSelector = (data) => {
  return (<FieldProvider render={(props: any) => {

    const { input } = useFieldApi({
      name: data.name,
      initialValue: data.initialValue,
      validate: data.validate,
      useWarnings: true
    });

    return (
      <Box sx={{
        width: '100%',
      }} className={"MuiGrid-item MuiGrid-grid-xs-12 FormFieldGrid-grid"} display={'flex'} flexDirection={'column'}>
        {data.attribute?.map((attrib, attrIndex) => {
          // Find the selected attribute value consistently
          const [selectedAttr] = input.value?.filter(
            (attr: { productAttributeId: any; }) => attr.productAttributeId === attrib.id
          );

          // Get the ID of the selected attribute value
          const selectedValueId =
            selectedAttr?.productAttributeValueId || [];

          return (
            <Box key={`attrib-${attrIndex}`} sx={{width:"100%"}}>
              <InputLabel id={`label-${attrib.id}`}>
                {attrib.attribute.name}
              </InputLabel>
              <Select
                onChange={(e,productAttributeId) => {

                  const selectedOptionId = e.target.value;
                  const attribute =
                    data?.attribute?.find(
                      (attr) => attr.productAttributeValues?.some(
                        (option) => option.id === selectedOptionId
                      )
                    );

                  let attributeText = '';
                  if (attribute) {
                    const selectedOption = attribute.productAttributeValues?.find(
                      (option) => option.id === selectedOptionId
                    );
                    if (selectedOption) {
                      attributeText = selectedOption.attributeValue.value;
                    }
                  }
                  const newPayload = [
                    ...data.initialValue.filter(attrib => attrib.productAttributeId !== attribute.id),
                    {
                      productAttributeId: attribute.id,
                      productAttributeValueId: selectedOptionId,
                      productAttributeValue: attributeText
                    }];
                  input.onChange(newPayload);
                }}
                labelId={`label-${attrib.id}`}
                id={`select-${attrib.id}`}
                fullWidth={true}
                multiple={false}
                value={selectedValueId}
              >
                {attrib?.productAttributeValues?.map(
                  (option, menuIndex) => (
                    <MenuItem key={`menu-${menuIndex}`} value={option.id}>
                      {option.attributeValue.value}
                    </MenuItem>
                  )
                )}
              </Select>
              <br />
            </Box>
          );
        })}
      </Box>
    );


  }
  } />);
};
export const TagFieldProvider = (data) => {

  return (<FieldProvider render={(props: any) => {

    const { input, meta } = useFieldApi({
      name: data.name,
      initialValue: data.initialValue,
      validate: data.validate,
      useWarnings: true
    });


    const { label, selectOptions } = data;
    return (
      <Box sx={{ minWidth: '100%', marginTop: 4 }}>
        <Autocomplete
          multiple
          id="tags-standard"
          options={data.options}
          getOptionLabel={(option) => option.label}
          onChange={(e: any, value) => {


            input.onChange(value);
          }}
          value={input.value || []}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label={label}
              placeholder={data.placeholder}
            />
          )}
        />
      </Box>
    );
  }
  }
  />);
};
